const CATEGORIES = {
    INTERACTION: 'interaction',
    IMPRESSION: 'impression',
    VIEW: 'view',
    SCROLL: 'scroll',
};

const ENVS = {
    PROD: 'prod',
    STAGE: 'stage',
    DEV: 'dev',
};

module.exports = {
    CATEGORIES,
    ENVS,
};
